(function () {
  "use strict";

  function $(sel, root) {
    return (root || document).querySelector(sel);
  }

  function bindGallery() {
    var main = $("#nl-pdp-main-img");
    if (!main) return;
    document.querySelectorAll(".nl-pdp-thumb").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var src = btn.getAttribute("data-src");
        var alt = btn.getAttribute("data-alt") || "";
        if (!src) return;
        main.src = src;
        main.alt = alt;
        document.querySelectorAll(".nl-pdp-thumb").forEach(function (b) {
          b.classList.toggle("is-active", b === btn);
        });
      });
    });
  }

  function scrollToPlans() {
    document.querySelectorAll(".nl-pdp-scroll-plans").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var block = document.getElementById("nl-yo-checkout");
        if (block) block.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    });
  }

  function boot() {
    bindGallery();
    scrollToPlans();
    if (window.NLTracking && window.NLTracking.track) {
      window.NLTracking.track("ViewContent", {
        content_name: "Nightlight Product Page",
        content_category: "month_one",
      });
    }
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
